import { render, staticRenderFns } from "./BrainsChart.vue?vue&type=template&id=fff77eca&scoped=true&"
import script from "./BrainsChart.vue?vue&type=script&lang=js&"
export * from "./BrainsChart.vue?vue&type=script&lang=js&"
import style0 from "./BrainsChart.vue?vue&type=style&index=0&id=fff77eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff77eca",
  null
  
)

export default component.exports